import React from "react";

import "./index.scss";

const RequiredFieldMarker = () => (
  <span className="cnc-required-field-marker">&nbsp;*</span>
);
export default RequiredFieldMarker;
